import { HStack, VStack } from '@cbhq/cds-web/layout';
import { Box } from '@cbhq/cds-web/layout/Box';
import { TextBody, TextCaption, TextHeadline, TextTitle3 } from '@cbhq/cds-web/typography';

import { ReactComponent as EthereumImg } from ':cloud/assets/Protocols/Logos/ethereum.svg';
import { ReactComponent as RewardsImg } from ':cloud/assets/Staking/Rewards.svg';

function StakingPricingCard() {
  return (
    <Box spacingVertical={1} spacingBottom={4} borderRadius="roundedLarge" borderColor="line">
      <VStack width="100%">
        <TextTitle3 spacingHorizontal={5} spacingVertical={3} as="h2">
          Pricing
        </TextTitle3>
        <VStack spacingHorizontal={2}>
          <TextCaption color="foregroundMuted" spacingHorizontal={2} spacingBottom={1} as="h3">
            MONTHLY
          </TextCaption>
          <HStack
            justifyContent="space-between"
            alignItems="center"
            spacingHorizontal={2}
            spacingVertical={1}
          >
            <HStack alignItems="center" gap={2}>
              <EthereumImg height={24} width={24} />
              <VStack>
                <TextHeadline as="h2">Ethereum (Mainnet)</TextHeadline>
                <TextBody color="foregroundMuted" as="p">
                  Dedicated Validators
                </TextBody>
              </VStack>
            </HStack>
            <VStack alignItems="flex-end">
              <TextBody as="p">8% of monthly</TextBody>
              <TextBody as="p">staking rewards</TextBody>
            </VStack>
          </HStack>
          <HStack
            justifyContent="space-between"
            alignItems="center"
            spacingHorizontal={2}
            spacingVertical={1}
          >
            <HStack alignItems="center" gap={2}>
              <RewardsImg height={24} width={24} />
              <VStack>
                <TextHeadline as="h2">Rewards data</TextHeadline>
                <TextBody color="foregroundMuted" as="p">
                  250 addresses/month
                </TextBody>
              </VStack>
            </HStack>
            <VStack alignItems="flex-end">
              <TextBody as="p">Free</TextBody>
              <TextBody color="foregroundMuted" as="p">
                then $0.04/address
              </TextBody>
            </VStack>
          </HStack>
        </VStack>
      </VStack>
    </Box>
  );
}

export default StakingPricingCard;
